import React from 'react';
import "react-dom";

import RouterHandler from "./router/router"



function App() {
  return (
    <div className="App">
      <RouterHandler/>
    </div>
  );
}

export default App;
